module.exports = __webpack_public_path__ + "components/flag/static/square/pn-4cd2b0af76f7971462c93317f8ef5c86.svg";